export default __webpack_public_path__ + "static/media/logo21.e089f3b9.svg";